(function() {
    'use strict';

    angular.module( APP_ID )
        .controller( 'PostgradsController', [ '$scope', '$controller', 'ContentSwitchingService', 'LoggerFactory', 'SelectablesService', 'SubpagesService', 'MetaService', 'Utils', 'CONFIG', PostgradsController ]);

    /**
     * Downloads and prepares data for a specific postgraduate programme
     * (academic, professional or graduate) and its subqualifications
     * (if there are any).
     *
     * @param {ng.IScope} $scope
     * @param {ng.IControllerService} $controller
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {LoggerFactory} LoggerFactory
     * @param {SelectablesService} SelectablesService
     * @param {SubpagesService} SubpagesService
     * @param {MetaService} MetaService
     * @param {Utils} Utils
     * @param {Object} CONFIG
     */
    function PostgradsController(
        $scope,
        $controller,

        ContentSwitchingService,
        LoggerFactory,
        SelectablesService,
        SubpagesService,
        MetaService,
        Utils,

        CONFIG
    ){
        // Helper members.

        /** @type {angular.IController} */
        var vm = this;

        /** @type {Logger} */
        var logger = LoggerFactory.createLogger( 'PostgradsController' );

        /** @type {BaseController} */
        var ctrl   = $controller( 'BasePageController', { 'vm': vm, 'logger': logger } );





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        function init(){
            overrideBaseController();
            ctrl.activate();
        };

        /** Run right after all the bindings are ready! */
        vm.$onInit = init;

        /** @destructor */
        vm.$onDestroy = function() {
            SelectablesService.deregisterUrlSync();
        }





        /* ===== CONTROLLER'S PUBLIC METHODS ================================ */
        
        /**
         * Boolean for view to determine which header style to show
         */
        vm.isGradQual = function() {
            return SubpagesService.isGraduateQualSubpage();
        }


        /* ===== PRIVATE FUNCTIONS ========================================== */


        /**
         * Overrides parental's controller behaviour and attaches hooks.
         *
         * _Note: MUST BE called BEFORE the parental controller is activated!_
         */
        function overrideBaseController() {
            var params = vm.$transition$.params();

            ctrl.contentRequestParams = {
                viewUrl: params[ CONFIG.PARAMS.POSTGRAD_ID ],
                urlPath: getApiBaseUrl()
            };

            ctrl.requiredContentAttributes.push( 'pages' );

            ctrl.preProcessResponse  = ctrl.prepareSubpagesFromResponse;
            ctrl.postProcessResponse = postProcessResponse;
        }

        function getApiBaseUrl(){
            switch( vm.$transition$.params()[ CONFIG.PARAMS.QUAL_TYPE ] ){
                case CONFIG.ROUTES.GRADUATE_QUALS: return CONFIG.API.CMS.PATHS.GRADUATE_QUALS;

                case CONFIG.ROUTES.OTHER_QUALS: return CONFIG.API.CMS.PATHS.OTHER_QUALS;

                default: return CONFIG.API.CMS.PATHS.POSTGRADS;
            }
        }


        /**
         * Is triggered AFTER getting a response from CMS, validating
         * all required attributes and processing part of the response.
         *
         * @param {Object} responseObject
         */
        function postProcessResponse( responseObject ) {
            var selectableAttribute = null;

            if ( vm.metadata.hasOwnProperty( 'childType' ) ){
                selectableAttribute = vm.metadata.childType;
                SubpagesService.setSelectableAttribute( selectableAttribute );
            } else {
                logger.error( "Attribute `childType` is not present in the response which will limit some features and might cause malfunctions.", vm.metadata );
            }
            

            if ( responseObject.references && responseObject.references.hasOwnProperty( 'qualifications' ) ){

                var qualsObject = responseObject.references.qualifications;

                vm.selectablesId = 'postgradQuals';

                SelectablesService.createQualifications( vm.selectablesId, qualsObject, selectableAttribute );
            } else {
                logger.error( "No qualifications were retrieved from the CMS.", responseObject.references );
            }

            // Expose indicator if 'PhD' block does exist or not in any of available tabs
            Utils.addPhdBlockMetaIfExists( vm.content );

            saveInfoToCookie();
            setPostWatchers();
        }


        /**
         * Sets up post-processing watchers tracking changes on
         * subqualifications.
         */
        function setPostWatchers() {
            // TODO: Heavy refactor!
            /** @type {Selectables} */
            var subqualSelectables  = SelectablesService.getSelectablesById( vm.selectablesId );
            var lastVisitedPage     = ContentSwitchingService.userSettings.lastVisitedPage;

            var TEMPLATE_META_QUALIFICATIONLESS = vm.metadata.name + ( vm.metadata.code ? ' [' + vm.metadata.code + ']' : '' );

            // Postgraduate or Graduate?
            var qualType = vm.$transition$.params()[ CONFIG.PARAMS.QUAL_TYPE ] === CONFIG.ROUTES.POSTGRADS ? 'postgrad' : 'graduate';

            // Postgraduate academic or postgraduate professional?
            var isProfessionalProgramme = SubpagesService.isProgrammeSelectable();
            var isSpecialisation = SubpagesService.isSpecialisationSelectable();

            $scope.$watch( function() {
                return subqualSelectables.model.primaryItem;
            }, function( newPrimaryItem ) {

                var metaTemplateBase;

                if ( isProfessionalProgramme && ! isSpecialisation) {
                    metaTemplateBase = newPrimaryItem ? newPrimaryItem.title : TEMPLATE_META_QUALIFICATIONLESS;
                } else {
                    metaTemplateBase = TEMPLATE_META_QUALIFICATIONLESS + ( newPrimaryItem ? ' focusing on ' + newPrimaryItem.title : '' );
                }

                MetaService.updateTitleStructure({
                    page: metaTemplateBase
                });

                MetaService.updateDescriptionStructure({
                    page: metaTemplateBase
                });

                /** TODO: What's this for exactly? */
                // Tracking sub-qualifications?
                if ( newPrimaryItem ) {

                    if ( newPrimaryItem.hasOwnProperty( 'metadata' ) ){
                        if ( qualType === 'postgrad' && vm.metadata.childType == 'programme' && newPrimaryItem.metadata.hasOwnProperty( 'internationalApiCode' ) ){
                            // Professional postgrad programmes use API code
                            lastVisitedPage[ qualType ][ 'subQual' ] = { apiCode: newPrimaryItem.metadata.internationalApiCode } ;
                        } else {
                            lastVisitedPage[ qualType ][ 'subQual' ] = { webPath: newPrimaryItem.metadata.id } ;
                        }
                    }
                } else if ( lastVisitedPage[ qualType ].hasOwnProperty( 'subQual' ) ) {
                    delete lastVisitedPage[ qualType ].subQual;
                }

                // Save updated user information to the cookies!
                if ( ContentSwitchingService.isCookieAvailable() ) ContentSwitchingService.saveSettingsToCookie();
            });
        }


        /**
         * Saves information about current postgraduate/graduate into a cookie,
         * if it was already created by the `ContentSwitchingService`.
         *
         * TODO: Make saving more efficient and transactional (instead of
         * calling `ContentSwitchingService.saveSettingsToCookie()` twice,
         * call it once).
         */
        function saveInfoToCookie() {
            var lastVisitedPage = ContentSwitchingService.userSettings.lastVisitedPage;

            // Postgraduate or Graduate? => Use Subpages
            var qualType = vm.$transition$.params()[ CONFIG.PARAMS.QUAL_TYPE ] === CONFIG.ROUTES.POSTGRADS ? 'postgrad' : 'graduate';

            /** @type {Selectables} */
            var subqualSelectables = SelectablesService.getSelectablesById( vm.selectablesId );

            if ( !lastVisitedPage.hasOwnProperty( qualType ) ) lastVisitedPage[ qualType ] = {};

            // TODO: Refactor when cleaning up postgrads!
            if ( vm.metadata.hasOwnProperty( 'internationalApiCode' ) && vm.metadata.internationalApiCode !== 'null' ){
                lastVisitedPage[ qualType ][ 'apiId' ]   = vm.metadata.internationalApiCode;

                if ( lastVisitedPage[ qualType].hasOwnProperty( 'webPath' ) ) delete lastVisitedPage[ qualType ].webPath;
            } else if ( subqualSelectables && vm.metadata.childType !== 'programme' && subqualSelectables.model.all.length > 0 && subqualSelectables.model.all[ 0 ].content.hasOwnProperty( 'asset_metadata_internationalApiCode' ) ) {
                lastVisitedPage[ qualType ][ 'apiId' ]   = subqualSelectables.model.all[ 0 ].content.asset_metadata_internationalApiCode; // TODO: Dangerous - fix if possible

                if ( lastVisitedPage[ qualType].hasOwnProperty( 'webPath' ) ) delete lastVisitedPage[ qualType ].webPath;
            } else {
                lastVisitedPage[ qualType ][ 'webPath' ] = vm.metadata.id;

                if ( lastVisitedPage[ qualType].hasOwnProperty( 'apiId' ) ) delete lastVisitedPage[ qualType ].apiId;
            }

            // Save updated user information to the cookies!
            if ( ContentSwitchingService.isCookieAvailable() ) ContentSwitchingService.saveSettingsToCookie();
        }
    }
})();
